// index.js

// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Import i18n configuration here

// Fix benign "ResizeObserver loop completed with undelivered notifications"
// warning at the source by wrapping every ResizeObserver callback in
// requestAnimationFrame — this defers the notification to the next frame so
// the observer never reports an unfinished loop. Canonical workaround used by
// many MUI-based apps and Chrome itself recommends it.
// See: https://github.com/WICG/resize-observer/issues/38
if (typeof window !== "undefined" && window.ResizeObserver) {
  const ResizeObserverOriginal = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserverPatched extends ResizeObserverOriginal {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

